import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPhotosUploading = isUploading => ({
  type: actionTypes.SET_AD_PHOTOS_UPLOADING,
  payload: isUploading
})
